/**
 * Every animation clip a character can play — one list, one line each.
 * `kind` is the prep rule the scene already applies: duo clips keep
 * authored root staging; solo clips are rebased.
 * Optional `endFrame` cuts the clip after that frame at bind (the clip's own fps; ours are 30). A file that is already that length is left as is.
 * bytes — the loader's fallback size when the server sends no Content-Length; update on re-export.
 */
export const CHARACTER_CLIPS = {
  sakira: {
    idleSolo: { url: '/models/sakira-solo-idle.glb', assetId: 'sakira-solo-idle', label: 'Sakira solo idle', kind: 'solo', bytes: 1676640 },
    idleDuo: { url: '/models/sakira-duo-idle.glb', assetId: 'sakira-duo-idle', label: 'Sakira duo idle', kind: 'duo', bytes: 2342344 },
    dance: { url: '/models/sakira-dance.glb', assetId: 'sakira-dance', label: 'Sakira dance', kind: 'duo', bytes: 2253336 },
    scared: { url: '/models/sakira-scared.glb', assetId: 'sakira-scared', label: 'Sakira scared', kind: 'solo', bytes: 1011736 },
    clap: { url: '/models/sakira-clap.glb', assetId: 'sakira-clap', label: 'Sakira clap', kind: 'solo', endFrame: 340, bytes: 2418540 },
    headShake: { url: '/models/sakira-head-shake.glb', assetId: 'sakira-head-shake', label: 'Sakira head shake', kind: 'solo', endFrame: 54, bytes: 849836 },
  },
  song: {
    idleSolo: { url: '/models/song-solo-idle.glb', assetId: 'song-solo-idle', label: 'Song solo idle', kind: 'solo', bytes: 1405712 },
    idleDuo: { url: '/models/song-duo-idle.glb', assetId: 'song-duo-idle', label: 'Song duo idle', kind: 'duo', bytes: 2826556 },
    dance: { url: '/models/song-dance.glb', assetId: 'song-dance', label: 'Song dance', kind: 'duo', bytes: 2594052 },
    scared: { url: '/models/song-scared.glb', assetId: 'song-scared', label: 'Song scared', kind: 'solo', bytes: 1225740 },
    clap: { url: '/models/song-clap.glb', assetId: 'song-clap', label: 'Song clap', kind: 'solo', endFrame: 340, bytes: 2348872 },
    headShake: { url: '/models/song-head-shake.glb', assetId: 'song-head-shake', label: 'Song head shake', kind: 'solo', endFrame: 54, bytes: 856032 },
  },
}

export const PHASE2_CLIP_STATES = ['dance', 'scared', 'clap', 'headShake']

export const CLIP_ASSET_BYTES = Object.fromEntries(
  Object.values(CHARACTER_CLIPS).flatMap((clips) => Object.values(clips).map((c) => [c.assetId, c.bytes || 0]))
)
export const IDLE_ASSET_IDS = ['sakira', 'song'].flatMap((n) => [CHARACTER_CLIPS[n].idleSolo.assetId, CHARACTER_CLIPS[n].idleDuo.assetId])
